import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { setupFetchAuthInterceptor } from "./utils/setupFetchInterceptor";
import { purgeStoredSession } from "./config/access";
import { HelmetProvider } from 'react-helmet-async';

// Drop any persisted session before the tree mounts, so no authenticated UI
// renders once sessions are closed (KAT-230). No-op while they are open.
purgeStoredSession();

setupFetchAuthInterceptor();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
